import { ParticipantDetails, SocketConnected, UserDetails, deviceState, sharingState, SocketMeetDetails } from "../models/meetModal";
import { socketioSDK } from "meeting-socketio-sdk";
import { getToken, hassAccess, summarySubjectHandler } from "../utils";
import { v4 as uuidv4 } from "uuid";
import socketioClient from 'meeting-socketio-sdk/lib/socketioClient';
import _ from "lodash";
import { VideoCallSDK } from "ccaas_videomeet_sdk";
import { GetItemFromStorage, SetItemInStorage } from "../../custom_hooks/useStorage";
import { LocalStorage } from "../../custom_hooks/localStorageKeys";
import { storeConversationChatDetails, activeSpeakerDetect, downloadRecFile, fetchBrowserTpeRec, participantAddRemove, setcloseCaptionText, sipCallEnd, storeCallStatus, storeParticipantVideo, storeTranscript, throwLoading, throwReconnect, throwWaitingRoom, updatedParticipatList, updateSockMeetDetails, versioDetection, updateCloseCaptionLang, setRecTimer, readCountStoreChat, updateCCLang, stopScreenSharing, storeChatConvo, iterateSoreChat, formatTime, setVerifyModals, setVerificationDetails, updateImage, setVerifyInitialState, setDocModal, sendAiAssistData } from "../video_common";
import { screenShareReducerAction } from "../../store/slices/screenshare_slice/screensharedata";
import { unMuteWithNewStream, videoDisable, meetService, video_disable } from "../../services/meetService";
import store from "../../store/redux-store/root_store";
import { Types, actionTypes, meetActionTypes } from "../action/action";
import { message, notification } from "antd";
import { ROLES, config } from "../constant";
import { clearCanvas, receivingPoint, reset, resizeCanvas, startCanvascanvasAgent, toast } from "../../annotation";
import { ChatActions } from "../../store/slices/chat_slice/chat_slice";
import presenceService from "./presence";
import { MeetServices } from "./apiServices";

let eventE: any = null;
let that: any;
var player = new Audio();
let disconnectTimer: any = null;
let socketIOSDK: socketioClient;
let {
  UnMute_AudioCall, Mute_AudioCall, startScreenShare
} = VideoCallSDK.Video;
export class videoCallService {
  public static io: any;
  static _instance: any;
  public dispatch: any;
  public token: any;
  static videoCallServiceSoc: any
  public meetServiceCall: any
  constructor(dispatch?: any) {
    this.dispatch = dispatch;
    that = this;
    this.meetServiceCall = new meetService(dispatch);
  }

  public createConnection = (meeting: string, transferKey: any, username?: string) => {
    const meetingDetails: any = store.getState().meetingReducer;
    const userDetials = GetItemFromStorage(LocalStorage.USER_DETAILS);
    const LoginUserDetails: any = userDetials;
    console.log("createConnection calling");
    socketIOSDK = new socketioSDK.socketioClient();
    console.log(socketIOSDK, "socketIOSDK===");

    let { isTransoportClose } = store.getState().meetingReducer;
    let isHostCheck = _.filter(meetingDetails.meetingDetails.participants, function (o: any) {
      return (o.roletype === 1 &&
        o.user_type === "company" && o.sipid === LoginUserDetails.sip_login_id);
    });
    let videoConstrain: boolean = meetingDetails.videoToggle;
    let audioConstrain: boolean = meetingDetails.muteToggle;

    if (isHostCheck.length === 0) {
      if (meetingDetails.meetingDetails.is_participant_video === true) {
        videoConstrain = meetingDetails.videoToggle;
      }
      else {
        videoConstrain = meetingDetails.meetingDetails.is_participant_video
      }
    } else {
      videoConstrain = meetingDetails.videoToggle
      if (!meetingDetails.meetingDetails.is_host_myvideo)
        videoConstrain = meetingDetails.meetingDetails.is_host_myvideo || false
    }
    // let mediaDeviceInfo: deviceState = store.getState().mediaDevice;
    // if (!mediaDeviceInfo.isVideo) { videoConstrain = mediaDeviceInfo.isVideo; }
    // if (!mediaDeviceInfo.isAudio) { audioConstrain = false; }
    socketIOSDK.removeAllEventListeners();
    eventE = socketIOSDK.getEventEmitter();
    eventE?.removeAllListeners();

    this.socketEvents();
    const uuid = uuidv4();
    SetItemInStorage("isLoggedIn", "1");
    const deviceid = GetItemFromStorage("deviceid");
    const tokens = GetItemFromStorage("ACCESS_TOKEN");
    if (!deviceid) SetItemInStorage("deviceid", uuid);
    let jwt: string = tokens || '';
    const obj =
    {
      url: config().BASE_URL,
      meetingId: meeting,
      deviceid: deviceid ? deviceid : uuid,
      token: jwt, username: username, isAudio: audioConstrain, isVideo: videoConstrain, transfer: transferKey
    };
    console.log("objjj", obj);
    if (disconnectTimer) clearTimeout(disconnectTimer)
    updatedParticipatList([]);

    if (isTransoportClose) {
      store.dispatch({
        type: meetActionTypes.IS_TRANSPORT_CLOSE,
        payload: {
          isTransoportClose: false
        }
      });
    };

    store.dispatch({
      type: meetActionTypes.IS_SOCKET_INIT,
      payload: {
        isSocketInit: true
      }
    });
    console.log("After disconnectTimer >>>>>>", disconnectTimer);
    socketIOSDK.createConnection(obj);
  }

  public static sendScreenShare(data: object) {
    if (socketIOSDK) {
      socketIOSDK.joinScreenShare(data);
    }
  };

  socketEvents = () => {
    console.log("socket eventttts");
    eventE.on('connect_failed', (msg: any) => {
      console.log("Internet Connection Failed!!!");
    });

    eventE.on("disconnect", (msg: any) => {
      console.log("disconnect===>", msg);
      if (msg === "io server disconnect") {
        new meetService(this.dispatch).stopScreenSharing();
        localStorage.removeItem('isLoggedIn');
        localStorage.removeItem('createConnection');

      } else if (msg === "transport close") {
        console.log("transportColse>>>>>")
        store.dispatch({
          type: meetActionTypes.IS_SOCKET_INIT,
          payload: {
            isSocketInit: false
          }
        });

        store.dispatch({
          type: meetActionTypes.IS_TRANSPORT_CLOSE,
          payload: {
            isTransoportClose: true
          }
        });

        updatedParticipatList([]);
        this.disconnectAndJoin();
      } else if (msg === "transport error") {

        console.log("transport error");
        this.disconnectAndJoin();
      } else if (msg === "ping timeout") {
        console.log("ping timeout");
        this.disconnectAndJoin();
      }
      else if (msg === "io client disconnect") {

        store.dispatch({
          type: meetActionTypes.IS_SOCKET_INIT,
          payload: {
            isSocketInit: true
          }
        });
        console.log("client disconecting the call");
        sipCallEnd();
      }
    });

    eventE.on("connect_error", (msg: any) => {

      new meetService(this.dispatch).throwError(msg?.message?.indexOf('poll error') > -1 ? "Something went wrong!!!" : msg.message);
      if (msg?.message?.indexOf('poll error') > -1) {
        console.log("poll error >>>>>");
        throwReconnect(true);
      }
      if (msg?.message?.indexOf('timeout') > -1) {
        new meetService(this.dispatch).throwError("Something went wrong!!!");
        throwLoading(false);
      }
      throwLoading(false);
    });
    eventE.on("updateCCLang", (message: any) => {
      updateCloseCaptionLang(message);
    });

    eventE.on("activeSpeaker", (message: any) => {
      if (message) {
        let { activeParticipantList, currdeviceinfo }: any = store.getState().meetingReducer;
        let index = activeParticipantList.findIndex((elem: ParticipantDetails) =>
          (elem.conId === message.speaker_socketId));
        if (index !== -1) {
          activeParticipantList[index].isActive = (message.message === "speaking") ? true : false;
          if (currdeviceinfo.conId !== (message.speaker_socketId).toString()) {
            activeSpeakerDetect(message);
          }
          store.dispatch({
            type: meetActionTypes.UPDATE_ACTIVE_PARTICIPANT,
            payload: { activeParticipantList: activeParticipantList }
          });
        }
      }
    });

    eventE.on("vm_settings", async (message: any) => {
      store.dispatch({
        type: meetActionTypes.VM_SETTINGS,
        payload: {
          vmSettings: message.settings
        }
      })

    });

    eventE.on("transfer_initiated", async (message: any) => {
      store.dispatch({
        type: meetActionTypes.VM_TRANSFER,
        payload: {
          vmTransfer: message.type,
          vmTransferDropdown: false,
          vm_acd_event: 0,
          vmTransferDetails: (message.details && (message.type === "transfer_initiated" || message.type === "transfered_connected")) ? message.details : {}
        }
      })

      if (message.type === "transfer_initiated") {
        store.dispatch({
          type: meetActionTypes.VM_TRANSFER_TIME,
          payload: {
            vmTransferTimer: 0,
            vmTransferStartTime: new Date().getTime()
          }
        })
        toast("Video call has been transferred successfully");
      }
      if (message.type === "transfer_declined") {
        store.dispatch({
          type: meetActionTypes.VM_TRANSFER_TIME,
          payload: {
            vmTransferTimer: 0,
            vmTransferStartTime: 0
          }
        })
      }
      else if (message.type === "transfer_connected_end") {
        videoCallService.endMeeting("leave");
      }
      else if (message.type === "transfer_connected_continue") {
        store.dispatch({
          type: meetActionTypes.VM_TRANSFER_TIME,
          payload: {
            vmTransferTimer: 0,
            vmTransferStartTime: 0
          }
        })

      }
    });

    eventE.on("hideAll", async (message: any) => {
      let { currdeviceinfo } = store.getState().meetingReducer || [];
      let videoRenderList: any = store.getState().storeVideo.participantList || [];
      let videoData: any = _.find(videoRenderList, { participants: currdeviceinfo.conId });
      if (message && message.meetingdetails) {
        updateSockMeetDetails(message);
        if (!message.video) { videoDisable(); }
        if (message.audio) {
          if (videoData !== undefined) {
            Mute_AudioCall(videoData.userAgent);
          }
        }
        if (message.video) {
          let { participantList, midValue, callStatus } = store.getState().storeVideo || [];
          var constraints = {
            audio: false,
            video: { width: 1280, height: 720, frameRate: { ideal: 25, max: 30 } }
          };

          let mediaStream = await navigator.mediaDevices.getUserMedia(constraints);
          var pc: any = participantList[0].userAgent.sessionDescriptionHandler.peerConnection;
          pc.getSenders().forEach((sender: any, index: number) => {
            if (index === 1) {
              sender.replaceTrack(mediaStream.getVideoTracks()[0]);
            }
          });
          let replaceStream: any = participantList[0].stream;
          var videoTrack = replaceStream.getVideoTracks();
          if (videoTrack.length > 0) {
            replaceStream.removeTrack(videoTrack[0]);
          }
          replaceStream.addTrack(mediaStream.getVideoTracks()[0]);
          participantList[0].stream = replaceStream;
          storeParticipantVideo(participantList, midValue, callStatus);
        }

        if (!message.audio) {
          if (videoData !== undefined) {
            UnMute_AudioCall(videoData.userAgent);
          }
        }

      }
    });







    eventE.on("connectStatus", async (message: SocketConnected) => {
      console.log("connectStatus===>", message);
      // updateJoinArrowKey(false);
      // updateInstanmeetingLoader(false);
      if (message && message.meetingdetails) {

        if (message?.isConnected) {
          store.dispatch({
            type: meetActionTypes.UPDATE_CONN_STATUS,
            payload: {
              connstatus: message?.isConnected
            }
          });
        }

        updateSockMeetDetails(message, "", "movetowaitroom");
        storeConversationChatDetails(message)
        const { activeParticipantList, instatus, autoDraggable }: any = store.getState().meetingReducer;
        let { socketData, callStatus }: any = store.getState().storeVideo || [];
        console.log("connectStatus socketData >>>", socketData);

        throwReconnect(false);
        if (instatus !== 'transport close') {

          if (!message.meetingdetails.isParticipantjoinbefhost && !message.meetingdetails.isHostjoined) {
            throwLoading(false);
          }
          else {
            if (activeParticipantList.length > 1) {
              setTimeout(() => {
                throwLoading(false);
              }, 1000);
            } else {
              throwLoading(false);
            }
          }

        }
      }
    });

    eventE.on("closecaption", async (data: any) => {
      let { oriTranscript } = store.getState().closeCaption;
      let trans_data: any = { ...data };
      let duplicateIndex: any = _.findIndex(oriTranscript, { deviceid: data.deviceid });
      if (duplicateIndex > -1) {
        let lastIndex =
          oriTranscript?.length >= 1 &&
            trans_data.deviceid === oriTranscript[oriTranscript?.length - 1].deviceid ? true : false;
        if (lastIndex) {
          if (oriTranscript[oriTranscript?.length - 1]?.finalText?.length < 250) {
            let diff: any = 250 - oriTranscript[oriTranscript?.length - 1]?.finalText?.length;
            const sentencePattern = /[^.!?]+[.!?]/g;
            if (trans_data.text.length <= diff) {
              oriTranscript[oriTranscript.length - 1].finalText = oriTranscript[oriTranscript?.length - 1]?.finalText?.concat(" ", data.text)
              oriTranscript[oriTranscript.length - 1].finalconvertedText = oriTranscript[oriTranscript?.length - 1]?.finalconvertedText?.concat(" ", data.convertedText)
              storeTranscript(oriTranscript);
            }
            else {
              if (trans_data.text.match(sentencePattern) && trans_data.convertedText.match(sentencePattern)) {
                const meaningfulSentence = trans_data.text.match(sentencePattern)[0];
                const meaningFulConverted = trans_data.convertedText.match(sentencePattern)[0];
                oriTranscript[oriTranscript?.length - 1].finalText = oriTranscript[oriTranscript?.length - 1]?.finalText?.concat(" ", meaningfulSentence)
                oriTranscript[oriTranscript?.length - 1].finalconvertedText = oriTranscript[oriTranscript?.length - 1]?.finalconvertedText?.concat(" ", meaningFulConverted)
                storeTranscript(oriTranscript);

                const remainingText = trans_data.text.slice(meaningfulSentence?.length).trim();
                const remainingConvertedText = trans_data.convertedText.slice(meaningFulConverted?.length).trim();
                if (remainingText && remainingConvertedText) {
                  trans_data.timeStamp = new Date().getTime();
                  trans_data.finalText = remainingText; trans_data.finalconvertedText = remainingConvertedText;
                  oriTranscript.push(trans_data);
                  storeTranscript(oriTranscript);
                }
              }
            }
          }
          else {
            trans_data.timeStamp = new Date().getTime();
            trans_data.finalText = data.text; trans_data.finalconvertedText = data.convertedText;
            oriTranscript.push(trans_data);
            storeTranscript(oriTranscript);
          }
        }
        else {
          trans_data.timeStamp = new Date().getTime();
          trans_data.finalText = data.text; trans_data.finalconvertedText = data.convertedText;
          oriTranscript.push(trans_data);
          storeTranscript(oriTranscript);
        }
      }
      else {
        trans_data.timeStamp = new Date().getTime();
        trans_data.finalText = data.text; trans_data.finalconvertedText = data.convertedText;
        oriTranscript.push(trans_data);
        storeTranscript(oriTranscript);
      }
    })


    eventE.on("closecaption", async (data: any) => {
      let cc_data: any = data;
      let {currdeviceinfo,activeParticipantList}:any=store.getState().meetingReducer;
      let customerdetails: any = activeParticipantList.filter((ele: any) => { return (ele.isGuest  && !ele.conId.includes("_screenshare"))}) || [];
      if(!cc_data.isHost && customerdetails?.length > 0 && (currdeviceinfo.conId !== customerdetails[0]?.conId)){sendAiAssistData(cc_data);}  
      let { closeCaptionText } = store.getState().closeCaption;
      let duplicateIndex: any = _.findIndex(closeCaptionText, { deviceid: data.deviceid });
      if (duplicateIndex > -1) {
        let lastIndex =
          closeCaptionText?.length >= 1 &&
            data.deviceid === closeCaptionText[closeCaptionText.length - 1].deviceid ? true : false;
        if (lastIndex) {
          if (data.isFinal) {
            closeCaptionText[closeCaptionText.length - 1].finalText = closeCaptionText[closeCaptionText.length - 1]?.finalText?.concat(" ", data.text)
            closeCaptionText[closeCaptionText.length - 1].finalconvertedText = closeCaptionText[closeCaptionText.length - 1]?.finalconvertedText?.concat(" ", data.convertedText)
          }
          setcloseCaptionText(closeCaptionText);
        }
        else if (closeCaptionText.length === 3 || (duplicateIndex > -1 && !lastIndex)) {
          cc_data.finalText = data.text; cc_data.finalconvertedText = data.convertedText;
          closeCaptionText.splice(duplicateIndex, 1);
          closeCaptionText.push(cc_data);
          setcloseCaptionText(closeCaptionText);
        }
      }
      else {
        cc_data.finalText = data.text; cc_data.finalconvertedText = data.convertedText;
        closeCaptionText.push(cc_data);
        setcloseCaptionText(closeCaptionText);
      }
    });

    eventE.on("join_initialized", (message: any) => {
      console.log("join_initialized calling", message);
      if (disconnectTimer) clearTimeout(disconnectTimer)
      let { isTransoportClose, isSocketInit } = store.getState().meetingReducer;
      const meetingDetails = message.meetingdetails;
      let deviceInfo = meetingDetails.devicesInfo;
      let joinedParticipantList: Array<ParticipantDetails> = [];
      let joinedParticipantListHost: Array<ParticipantDetails> = [];
      let waitingRoomList: Array<ParticipantDetails> = [];
      let enableRecordingList: Array<ParticipantDetails> = [];
      const deviceid = GetItemFromStorage('deviceid') || '';
      let { participantList, midValue } = store.getState().storeVideo || [];
      let currentDeviceInfo: any | {} = {};
      if (!_.isEmpty(deviceInfo) && deviceid && !_.isEmpty(deviceInfo[deviceid])) {
        currentDeviceInfo = deviceInfo[deviceid];
      }
      console.log("isTransoportClose >>>>>>>", isTransoportClose);
      throwLoading(true);


      if (!isSocketInit) {
        store.dispatch({
          type: meetActionTypes.IS_SOCKET_INIT,
          payload: {
            isSocketInit: true
          }
        });
      }
      if (isTransoportClose) {
        store.dispatch({
          type: meetActionTypes.IS_TRANSPORT_CLOSE,
          payload: {
            isTransoportClose: false
          }
        });
      }




      store.dispatch({
        type: meetActionTypes.SOCKET_MEETING_DETAILS,
        payload: {
          sockmeetDetails: message.meetingdetails,
          connstatus: 'join_init',
          isError: { message: '' },
          activeParticipantList: joinedParticipantList,
          activeParticipantListWH: joinedParticipantListHost,
          waitingRoomList: waitingRoomList,
          recordingEnabledList: enableRecordingList,
          currdeviceid: deviceid,
          currdeviceinfo: currentDeviceInfo
        }
      });

      store.dispatch({
        type: meetActionTypes.UPDATE_CONN_STATUS,
        payload: {
          connstatus: 'join_init'
        }
      });

      storeParticipantVideo([], 2, "Waiting");
      let medium: string = "null";
      if (message.user_details && message.user_details.isGuest) {
        let data: string = GetItemFromStorage("guest") || '';
        if (data !== '') {
          medium = message.user_details.video ? "video" : !message.user_details.mute ? "audio" : "null";
          let meetservice: any = new meetService(this.dispatch);
          meetservice.createCallConnection(data, medium, true, message.socketid, message.user_details);
        }
      }
      else {
        const userDetials = GetItemFromStorage(LocalStorage.USER_DETAILS);
        const LoginUserDetails: any = userDetials;
        medium = message.user_details.video ? "video" : !message.user_details.mute ? "audio" : "null";
        let meetservice: any = new meetService(this.dispatch);
        meetservice.createCallConnection(LoginUserDetails, medium, false, message.socketid, message.user_details);
      }
    });



    eventE.on("insert_rec_cc", (data: any) => {
      let { recordTranscript, recordId }: any = store.getState().closeCaption;
      let { currdeviceinfo, elapsedTime }: any = store.getState().meetingReducer;
      let cc_data: any = data;
      cc_data["timer"] = formatTime(elapsedTime);
      recordTranscript.push(cc_data);
      store.dispatch({
        type: meetActionTypes.RECORD_TRANSCRIPT,
        payload: {
          recordTranscript: recordTranscript,
          recordId: recordId
        }
      })
    })

    eventE.on("sdp_sent_to_client", (msg: any) => {
      console.log("received response sdp from socket is", msg.sdp);
      new meetService(that.dispatch).receivedAnswerSdp(msg);
    });

    eventE.on("updated_participant_list", (message: any) => {
      console.log("updated_participant_list===>", message.participantList);
      let { socketData } = store.getState().storeVideo || [];
      if (!_.isEqual(message.participantList, socketData)) {
        console.log(socketData, "socketDataequal==");
        console.log(message.participantList, "message.participantList==");

        updatedParticipatList(message.participantList);
        const { callStatus } = store.getState().storeVideo || [];

        console.log("callStatus is", callStatus);
        if (callStatus === "Ready") {
          new meetService().sendingReinvite(message.participantList);
        }
        else {
          storeCallStatus(true);
        }
      }
    });

    eventE.on("closeCaptionStarted", (message: any) => {
      let { transcriptOpen } = store.getState().closeCaption;
      store.dispatch({
        type: meetActionTypes.CC_STATUS,
        payload: {
          captionStatus: false,
          captionBoolean: false,
          transcriptOpen: transcriptOpen
        }
      });
      store.dispatch({
        type: meetActionTypes.CLOSE_CAPTION,
        payload: {
          ccBtns: true,
          fontSize: 16,
          closeCaptionText: [],
          showOriginalText: false
        }
      });
    });

    eventE.on("closeCaptionEnded", (message: any) => {
      let { transcriptOpen } = store.getState().closeCaption;
      updateCCLang("en");
      store.dispatch({
        type: meetActionTypes.CC_STATUS,
        payload: {
          captionStatus: false,
          captionBoolean: false,
          transcriptOpen: transcriptOpen
        }
      });
      store.dispatch({
        type: meetActionTypes.CLOSE_CAPTION,
        payload: {
          ccBtns: false,
          fontSize: 16,
          closeCaptionText: [],
          showOriginalText: false
        }
      });
      toast("Closed caption is OFF");
    });



    eventE.on("meetingStatus", (message: any) => {
      console.log("meetingStatus===>", message);
      if (message && message.meetingdetails) {
        try {
          updateSockMeetDetails(message);
          const meetingDetails: SocketMeetDetails = message.meetingdetails;
          const { currdeviceid, pin, activeSpeaker, currdeviceinfo }: any = store.getState().meetingReducer;
          if (Object.keys(meetingDetails?.devicesInfo).length > 0) {
            const deviceInfo = meetingDetails?.devicesInfo ? Object.values(meetingDetails?.devicesInfo) : [];
            if (deviceInfo && currdeviceid && (message?.message?.toString().toLowerCase().indexOf('joined') > -1
              || message?.message?.toString().toLowerCase().indexOf('waiting') > -1)) {
              const deviceDetails: Array<any> = deviceInfo.filter((value: any) => value.conId.toString()
                === message.socketid.toString());
              const deviceDetailsData = meetingDetails?.devicesInfo[currdeviceid];
              if (deviceDetails && deviceDetails.length > 0 && (deviceDetails[0].moveToWaitingRoom
                && deviceDetailsData.isHost && deviceDetails[0].status === 'inWaitingroom')) {
                throwWaitingRoom(true);
              }
            }
          }
          // removing stored video session...
          let userStage: string = message.message.trim() || '';
          console.log("userStage", userStage);
          var name = message.message.trim();
          let index = name.includes('Left the meeting') ? name.indexOf('Left the meeting')
            : name.includes('Disconneted from the meeting') ? name.indexOf('Disconneted from the meeting') :
              name.includes('Joined the meeting') ? name.indexOf('Joined the meeting') : name;
          let toastt = userStage;
          if (index !== -1) {
            var name1 = name.slice(0, index);
            let lastmessage = name.includes('Left the meeting') ? "has left the meeting" : name.slice(index);
            var toastName = name1.length > 15 ? name1.substring(0, name1.indexOf(' ')) : name1;
            toastt = toastName + " " + lastmessage;
          }
          if (!userStage.includes('Joined the meeting')) {

            participantAddRemove('remove', message.socketid);
          }
          else {
            participantAddRemove('add', message.socketid);
          }

          if (userStage.includes('Left the meeting') || userStage.includes('Disconnected from the meeting') || userStage.includes('Joined the meeting')) {

            if (currdeviceinfo?.conId !== message?.socketid) { toast(toastt); }
            if (Object.keys(meetingDetails?.devicesInfo).length > 0) {
              let deviceInfo = meetingDetails?.devicesInfo ? Object.values(meetingDetails?.devicesInfo) : [];
              let removedParticipantDetail: any = _.find(deviceInfo, function (obj: any) {
                return obj.conId === message.socketid;
              })
            }
          }
        }
        catch (e: any) { console.log("error is", e); }
      }
    });


    eventE.on("screenShare", (msg: any) => {
      store.dispatch({
        type: meetActionTypes.FULL_SCREEN,
        payload: {
          fullScreenAgent: false,
          fullScreenCustomer: false
        }
      })
      const { annotation, annotationEnable } = store.getState().sharingReducerState;
      console.log("screenShare is calling", msg);
      updateSockMeetDetails(msg);
      store.dispatch({
        type: actionTypes.SCREENSHARING_STATUS,
        payloads: msg.message,
        connId: (msg.socketid ? msg.socketid : '')
      });
      if (annotation?.length === 0) { startCanvascanvasAgent(); }
      if (!msg.message && annotationEnable) {
        store.dispatch({
          type: actionTypes.ANNOTATE,
          payloads: {
            annotation: [], annotationCopy: []
          }
        })

        store.dispatch({
          type: actionTypes.ANNOTATION_STATUS,
          payloads: {
            annotationEnable: false,
            annotationPopup: false
          }
        })
        toast("Co-browsing stopped");
        reset();
      }
      if (!msg.message && !annotationEnable) {
        toast("Screen share has been stopped");
      }
    });
    eventE.on("hostStatus", (msg: any) => {
      console.log("msg>>", msg);
      updateSockMeetDetails(msg);
      store.dispatch({
        type: meetActionTypes.UPDATE_CONN_STATUS,
        payload: {
          connstatus: "connected"
        }
      });
    });

    eventE.on("audioMuteUnmute", async (message: any) => {
      console.log("audioMuteUnmute calling", message);
      updateSockMeetDetails(message);

      let videoRenderList: any = store.getState().storeVideo.participantList || [];
      let { currdeviceinfo }: any = store.getState().meetingReducer || [];
      if (currdeviceinfo.conId === message.socketid) {
        let videoData: any = _.find(videoRenderList, { participants: message.socketid });
        if (videoData !== undefined) {
          if (!currdeviceinfo.mute) {
            if (videoData.stream.getAudioTracks().length === 0) {

              console.log("<<<<<<<<< ALTER UNMUTE >>>>..");
              unMuteWithNewStream(message.socketid);
            }
            UnMute_AudioCall(videoData.userAgent);
          }
          else {
            Mute_AudioCall(videoData.userAgent);
          }
        }
      }
    });

    eventE.on("videoHideShow", (message: any) => {
      updateSockMeetDetails(message);
      let { currdeviceinfo }: any = store.getState().meetingReducer || [];
      if (currdeviceinfo.conId === message.socketid) {
        if (!currdeviceinfo.video) { videoDisable(); }
      }
    });

    eventE.on("activeSpeaker", (message: any) => {
      if (message) {
        let { activeParticipantList, currdeviceinfo }: any = store.getState().meetingReducer;
        let index = activeParticipantList.findIndex((elem: ParticipantDetails) =>
          (elem.conId === message.speaker_socketId));
        if (index !== -1) {
          activeParticipantList[index].isActive = (message.message === "speaking") ? true : false;
          if (currdeviceinfo.conId !== (message.speaker_socketId).toString()) {
            activeSpeakerDetect(message);
          }

          store.dispatch({
            type: meetActionTypes.UPDATE_ACTIVE_PARTICIPANT,
            payload: { activeParticipantList: activeParticipantList }
          });

        }
      }
    });

    eventE.on("recordingAction", async (message: any) => {
      let { currdeviceinfo, elapsedTime, pauseTime, recTimer }: any = store.getState().meetingReducer;
      const deviceid = GetItemFromStorage('deviceid') || '';
      const { recordTranscript }: any = store.getState().closeCaption;
      if (message.participantdetails.recordingStatus === "start") {
        if (currdeviceinfo.conId !== message.participantdetails.conId && message.recSettings?.length > 0) {
          if (message.recSettings[0].isVideoConsentNotice === 1)
            if (message.recSettings[0].isVideoTextToSpeech === 1 && message.recSettings[0].videoText.trim() !== "") {
              {
                if ('speechSynthesis' in window) {
                  const utterance = new SpeechSynthesisUtterance(message.recSettings[0].videoText);
                  utterance.lang = 'en-US';
                  utterance.pitch = 1;
                  utterance.rate = 1;
                  utterance.volume = 1;

                  // Speak the text
                  window.speechSynthesis.speak(utterance);
                } else {
                  console.log("browser not supported");
                }
              }
            }
            else if (message.recSettings[0].isVideoSelectPrompt === 1 && message.recSettings[0].videoUrl.trim() !== "") {
              const audio = new Audio(message.recSettings[0].videoUrl);
              audio.play();
            }
            else {
              console.log("else called");
            }
        }

        setRecTimer(0, 0, 0);
        const currentTime = Date.now();
        setRecTimer(currentTime - elapsedTime, pauseTime, elapsedTime);
        store.dispatch({
          type: meetActionTypes.RECORD_TRANSCRIPT,
          payload: {
            recordTranscript: recordTranscript,
            recordId: message.meetingdetails.recordId
          }
        })
      }
      else if (message.participantdetails.recordingStatus === "resume") {
        const pauseDuration = Date.now() - pauseTime;
        setRecTimer(recTimer + pauseDuration, pauseTime, elapsedTime);
      }
      else if (message.participantdetails.recordingStatus === "pause") {
        setRecTimer(recTimer, Date.now(), elapsedTime);
      }
      else if (message.participantdetails.recordingStatus === "stop") {
        const { recordTranscript }: any = store.getState().closeCaption;
        toast('Recording stopped');
        let data: any = {};
        data.recordId = message.meetingdetails.recordId;
        data.domain_id = message.meetingdetails.domain_id;
        data.recordTranscript = recordTranscript;
        if (currdeviceinfo.conId === message.participantdetails.conId && Array.isArray(recordTranscript) && recordTranscript?.length > 0) {
          await MeetServices.post(data, `insert_videomeet_record_transcript`).then((response: any) => {
            if (response?.data?.statusCode === 200) {
              console.log("inserted successfully========")
              store.dispatch({
                type: meetActionTypes.RECORD_TRANSCRIPT,
                payload: {
                  recordTranscript: [],
                  recordId: ""
                }
              })
            }
          }
          )
            .catch((err: any) => {
              console.log("insert rec transcript", err);
            })
          // downloadRecFile(message.participantdetails.recordFilePath);
        }

        setRecTimer(0, 0, 0);
      }
      updateSockMeetDetails(message);
    });

    eventE.on("endMeeting", async (msg: any) => {
      const sessionList = store.getState().chatReducer.sessionList;
      const getCookie: any = getToken();
      const { currdeviceinfo, videoCallDetails }: any = store.getState().meetingReducer;
      const meetingDetails: any = store.getState().meetingReducer;
      const { recordTranscript, recordId }: any = store.getState().closeCaption;
      const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
      const LoginUserDetails: any = userDetails;
      const LoginCcaasUserDetails = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
      setVerifyInitialState();
      try {
        hassAccess('Disposition/regenerate') && summarySubjectHandler({ isVideoChannel: true }, this.dispatch, 0);
        if (currdeviceinfo.recordingStatus !== "stop" && Array.isArray(recordTranscript) && recordTranscript?.length > 0) {
          let data: any = {};
          data.recordId = recordId;
          data.domain_id = meetingDetails.meetingDetails.agentDetails.domain_id;
          data.recordTranscript = recordTranscript;
          await MeetServices.post(data, `insert_videomeet_record_transcript`).then((response: any) => {
            if (response?.data?.statusCode === 200) {
              console.log("inserted successfully========")
            }
          }
          )
            .catch((err: any) => {
              console.log("insert rec transcript", err);
            })
        }
        console.log("else function====>");
        store.dispatch({
          type: meetActionTypes.AGENT_VIDEO,
          payload: {
            agentvideo: false,
            customerDetails: {}
          }
        });
        this.dispatch(ChatActions.endMeetingDispostion(msg?.meetingdetails?.meetingId))
        let sessiondt = sessionList.filter((res: any) => { return res.sessionId !== msg.meetingdetails.meetingId })
        // this.dispatch(ChatActions.currentChatSession(sessiondt?.length === 0 ? {} : sessiondt[0]))
        // this.dispatch(ChatActions.meetSessionList(sessiondt))
        const { agentStatus } = store.getState().agentState;
        const { users } = store.getState().userList;
        let status: any = null
        if (agentStatus?.length > 0) {
          [status] = agentStatus.filter((i: any) => { return "Ready" === i?.statusName?.trim() })
        }
        let enableStatus: any = null
        if (users.length > 0) {
          [enableStatus] = users?.filter((i: any) => { return LoginCcaasUserDetails?.emailId === i?.emailId })
        }
        console.log('presenceService 2', status, enableStatus);
        presenceService?.io?.emit("updatestate_backend", {
          domainId: LoginUserDetails?.domainId,
          isVoice: (enableStatus?.voice === 1 && status?.isVoice === 1) ? 1 : 0,
          isVoiceCallTransfer: status?.isVoiceCallTransfer ?? 0,
          isChat: (enableStatus?.chat === 1 && status?.isChat === 1) ? 1 : 0,
          isChatTransfer: status?.isChatTransfer ?? 0,
          isEmail: (enableStatus?.email === 1 && status?.isEmail === 1) ? 1 : 0,
          isEmailTransfer: status?.isEmailTransfer ?? 0,
          stateTime: Math.floor(Date.now() / 1000),
          statusName: "Ready",
          ext: LoginUserDetails?.ext,
          email: LoginUserDetails?.Email,
          userId: LoginUserDetails?.UserID,
          routingProfileId: LoginCcaasUserDetails?.routing_profile_id,
          userName: LoginCcaasUserDetails?.UserName,
          roleId: LoginCcaasUserDetails?.roleid,
          agentStatus: 1,
          skill: JSON.parse(enableStatus?.addSkill ?? '[]'),
          routingMethod: enableStatus?.routingMethod ?? 0
        });
        store.dispatch({
          type: meetActionTypes.RESET_VM_DETAILS
        });

        store.dispatch({
          type: meetActionTypes.UPDATE_VIRTUAL_STATUS,
          payload: {
            viewMode: "Active Speaker",
            peerConCheck: false
          }
        });


        setcloseCaptionText([]);
        stopScreenSharing();
        store.dispatch({
          type: meetActionTypes.ADD_MESSAGE,
          payload: {
            message: []
          }
        });

        store.dispatch({
          type: actionTypes.SCREENSHARING_STATUS,
          payloads: false,
          connId: ''
        });

        store.dispatch({
          type: meetActionTypes.MEETING_CONTROL_OPEN,
          payload: {
            componentState: "internalChat"
          }
        });

        store.dispatch({
          type: meetActionTypes.CUSTOMER_CONTROL_OPEN,
          payload: {
            customerComponentState: ""
          }
        })

        store.dispatch({
          type: meetActionTypes.FULL_SCREEN,
          payload: {
            fullScreenAgent: false,
            fullScreenCustomer: false
          }
        })
        store.dispatch({
          type: meetActionTypes.CLOSE_CAPTION,
          payload: {
            ccBtns: false,
            fontSize: 16,
            closeCaptionText: [],
            showOriginalText: false
          }
        });
        updatedParticipatList([]);
        storeTranscript([]);
        if (socketIOSDK) { socketIOSDK.socketDisconnect(); }
        localStorage.removeItem('isLoggedIn');
        localStorage.removeItem('createConnection');
        if (getCookie['guestToken']) {
          localStorage.removeItem('ACCESS_TOKEN');
          localStorage.removeItem('guest');
          localStorage.removeItem('USER_DETAILS');
          localStorage.removeItem('authorization');
          localStorage.removeItem('deviceid');
          localStorage.removeItem('chat');
          document.cookie = "guestToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=";
          store.dispatch({
            type: meetActionTypes.SOCK_THANK,
            payload: {
              connstatus: "disconnected",
              thankYou: true,
              isFailure: false,
              isError: '',
              cSatOpen: false
            }
          });

          setTimeout(() => {
            store.dispatch({
              type: meetActionTypes.SOCK_THANK,
              payload: {
                connstatus: "disconnected",
                thankYou: true,
                isFailure: false,
                isError: '',
                cSatOpen: true
              }
            });
          }, 2000)
        }
        else if (getCookie['ssoToken']) {

          store.dispatch({
            type: actionTypes.ANNOTATE,
            payloads: {
              annotation: [], annotationCopy: []
            }
          })

          store.dispatch({
            type: meetActionTypes.RECORD_TRANSCRIPT,
            payload: {
              recordTranscript: [],
              recordId: ""
            }
          })

          store.dispatch({
            type: actionTypes.ANNOTATION_STATUS,
            payloads: {
              annotationEnable: false,
              annotationPopup: false
            }
          })

          store.dispatch({
            type: actionTypes.RESIZE_CANVAS,
            payloads: {
              remoteVideoSize: {}
            }
          })

          const { cSatOpen }: any = store.getState().meetingReducer;

          setTimeout(() => {
            store.dispatch({
              type: meetActionTypes.SOCK_THANK,
              payload: {
                connstatus: "",
                thankYou: true,
                isFailure: false,
                isError: '',
                cSatOpen: cSatOpen
              }
            });
          }, 2000)
        }

        sipCallEnd();
        // new meetService(this.dispatch).resetMultiCheck();
      }
      catch (e: any) { console.log("error", e); }
    });

    eventE.on("video_announcement", (msg: any) => {
      console.log("video_announcement", msg);
      store.dispatch({
        type: meetActionTypes.QUEUE_ANNOUNCEMENT,
        payload: {
          announcementMsg: msg.message
        }
      })

      updateSockMeetDetails(msg)

    })


    eventE.on("participantRequestRecording", async (msg: any) => {
      store.dispatch({
        type: meetActionTypes.RECORD_UPDATE,
        payload: { recordAllowed: true }
      })
    })



    eventE.on("privateChat", (message: any) => {
      const { componentState, customerComponentState, currdeviceinfo } = store.getState().meetingReducer;
      const { chatConvo, toParticipant }: any = store.getState().messageReducer;
      const meetingReducerState = store.getState().messageReducer;
      if (meetingReducerState.toParticipant.deviceid !== "") {
        if (meetingReducerState.toParticipant.deviceid === message.from_deviceId
          || meetingReducerState.toParticipant.deviceid === message.to_deviceId || message.type === 'FILE') {
          store.dispatch({
            type: meetActionTypes.ADD_MESSAGE,
            payload: {
              message: message
            }
          });
        }

      }
      if (componentState !== "meetChat" || customerComponentState !== "customerChat" ||
        (meetingReducerState.toParticipant.deviceid !== message.from_deviceId)) {
        readCountStoreChat(message);
      }
      if (componentState === "meetChat" || customerComponentState === "customerChat") {
        iterateSoreChat(toParticipant);
        store.dispatch({
          type: meetActionTypes.CHAT_RECEIVE_ARRAY,
          payload: {
            chatConvo: []
          }
        })
      }
      if (message.to_deviceId !== "" && message.to_deviceId === currdeviceinfo.deviceid) {
        chatConvo.push(message);
        storeChatConvo(chatConvo);
      }
    });

    eventE.on("getChats", (message: any) => {
      store.dispatch({
        type: meetActionTypes.STORE_CONVERSATION,
        payload: { message: message }
      });
    });
    eventE.on("whiteBoard", (msg: any) => {
      const { currdeviceinfo } = store.getState().meetingReducer;
      const { annotation } = store.getState().sharingReducerState;
      console.log("whiteBoard is calling", msg);
      if (msg && msg.meetingdetails) {
        updateSockMeetDetails(msg);
      }
      if (annotation && annotation?.length === 0) { startCanvascanvasAgent(); }
      let parsed: any = JSON.parse(msg.message)
      console.log("parseddd", parsed.userId);
      if (parsed.userId !== currdeviceinfo.conId) { receivingPoint(JSON.parse(msg.message)); }
    });

    eventE.on("co_browser_req", (message: any) => {
      store.dispatch({
        type: actionTypes.ANNOTATION_STATUS, payloads: {
          annotationEnable: false, annotationPopup: true
        }
      })
    });
    eventE.on("co_browser_declined", (message: any) => {
      const { currdeviceinfo, activeParticipantList } = store.getState().meetingReducer;
      store.dispatch({
        type: actionTypes.ANNOTATION_STATUS, payloads: {
          annotationEnable: false, annotationPopup: false
        }
      })
      toast(message.conId === currdeviceinfo.conId ? `You denied co-browse request` : `Customer denied your co-browse request `)
    });
    eventE.on("co_browser_accepted", (message: any) => {

      let { annotationEnable } = store.getState().sharingReducerState;

      store.dispatch({
        type: actionTypes.ANNOTATION_STATUS,
        payloads: {
          annotationEnable: true,
          annotationPopup: false
        }
      })
    });
    eventE.on("update_canvas_size", (message: any) => {
      store.dispatch({
        type: actionTypes.RESIZE_CANVAS,
        payloads: {
          remoteVideoSize: {
            width: message.msg.width,
            height: message.msg.height
          }
        }
      })
    });

    eventE.on("verification_req", (message: any) => {
      const { isStore, isVerify, isFace, isDocs, isFaceDocs } = message.details
      setVerifyModals(true, false, true, false, false, false);
      setVerificationDetails(isStore, isVerify, isFace, isDocs, isFaceDocs)
    });

    eventE.on("verification_res", (message: any) => {
      const { currdeviceinfo } = store.getState().meetingReducer;
      const { isFace, isFaceDocs, isDocs, docSendDetails, isStore, isVerify, faceImgUrl, imgFile } = store.getState().verificationReducer;
      if (message.type === "res") {
        if (message.details.isAccept) {
          if (isFace || isFaceDocs) { setVerifyModals(true, false, false, false, (message?.details?.isAccept && (isFace || isFaceDocs)) ? true : false, false); }
          else if (isDocs || isFaceDocs) {
            setVerifyModals(true, false, false, false, false, false)
            setDocModal(currdeviceinfo.conId !== message.socketid ? true : false, {}, {}, false, false)
          }
        }
        else {
          if (currdeviceinfo.deviceid !== message.deviceid) {
            toast("Customer declined your request")
          }
          setVerifyInitialState();
        }
      }
      else if (message.type === "complete") {
        if (isFace) {
          setVerifyInitialState();
          toast(isStore ? "Face stored successfully" : "Face verified successfully")
        }
        else if (isDocs) {
          setVerifyInitialState();
          toast(isStore ? "Document stored successfully" : "Document verified successfully")
        }
        else if (isFaceDocs) {
          if (message.details?.verifyType !== "face") {
            setVerifyInitialState();
            toast(isStore ? "Face & Document stored successfully" : "Face & Document verified successfully")
          }
        }
      }
      else if (message.type === "failure") {
        if (isFace) {
          setVerifyInitialState();
          toast(isStore ? "Face storage failed" : "Face verification failed")
        }
        else if (isDocs) {
          setVerifyInitialState();
          toast(isStore ? "Document storage failed" : "Document verification failed")
        }
        else if (isFaceDocs) {
          if (message.details?.verifyType !== "face") {
            setVerifyInitialState();
            toast(isStore ? "Face & Document storage failed" : "Face & Document verification failed")
          }
        }
      }
      else if (message.type === "cancel") {
        if (currdeviceinfo.conId === message.socketid) {
          toast((isFace && isVerify) ? "Agent cancelled face verification" : (isDocs && isVerify) ? "Agent cancelled document verification" : (isFace && isStore) ? "Agent cancelled face storage" : "Agent cancelled document storage")
        }
        setVerifyInitialState();
      }
      else if (message.type === "doccapture") {
        setDocModal(false, docSendDetails, {}, true, false)
      }
      else if (message.type === "docdetails" && isVerify) {
        updateImage(0, imgFile, faceImgUrl, message?.details?.docImgUrl)
        setDocModal(false, message?.details?.docSendDetails, message?.details?.docReceiveDetails, false, true)
      }
    });

    eventE.on("verification_details", (message: any) => {
      try {
        let { imgFile, imgCount, faceImgUrl, docImgUrl, isStore, isVerify, isDocs, isFace, docSendDetails, isFaceDocs }: any = store.getState().verificationReducer;
        let { currdeviceinfo }: any = store.getState().meetingReducer;
        if (message.socketid === currdeviceinfo.conId) {
          updateImage(message.details?.count ? message.details?.count : imgCount, imgFile, message.details?.faceImgUrl ? message.details?.faceImgUrl : faceImgUrl, message.details?.docImgUrl ? message.details?.docImgUrl : docImgUrl)
          if ((isDocs || isFaceDocs) && message.details?.isImageCaptured && isVerify && message.details?.verifyType === "docs") {
            setVerifyModals(true, false, false, false, false, false)
            setDocModal(false, docSendDetails, message?.details?.docReceiveDetails, false, true)
          }
          if (isVerify && message.details?.isImageCaptured && message.details?.verifyType === "face" && (isFace || isFaceDocs)) {
            setVerifyModals(true, false, false, false, false, true)
            setDocModal(false, {}, [], false, false)
          }
        }
      }
      catch (err: any) {
        console.log("face verification listener errrror", err)
      }
    });


  }





  public disconnectAndJoin = () => {

    let { currdeviceinfo, meetingDetails }: any = store.getState().meetingReducer;
    console.log(currdeviceinfo, "currdeviceinfo", meetingDetails, "meetingDetails===");
    const isScreenShare: sharingState = store.getState().screenshare || [];
    let { participantList }: any = store.getState().storeVideo || [];

    let userSelfIndex = participantList.findIndex((elem: any) => elem.participants === currdeviceinfo.conId);
    console.log("participantList >>>>>>>", participantList, currdeviceinfo);
    if (userSelfIndex !== -1) {
      let pc: any = participantList[userSelfIndex].userAgent.sessionDescriptionHandler.peerConnection;
      console.log("pc >>>>>>", pc);
      pc.close();
    }

    if (isScreenShare.sharingStatus && isScreenShare.conId === currdeviceinfo.conId + "_screenshare") {
      new meetService(this.dispatch).stopScreenSharing();
      this.dispatch(screenShareReducerAction.screenShareStatus({ sharingStatus: false, conId: "" }))

    }
    else if (isScreenShare.sharingStatus) {

      this.dispatch(screenShareReducerAction.screenShareStatus({ sharingStatus: false, conId: "" }))

    }

    throwReconnect(true);
    storeParticipantVideo([], 2, "Waiting");
    store.dispatch({
      type: meetActionTypes.IS_SOCKET_INIT,
      payload: {
        isSocketInit: false
      }
    });
    if (socketIOSDK) { socketIOSDK.socketDisconnect(); }
    console.log("<<<<<<<< New connection Creating>>>>>>>>>>>>")
    setTimeout(() => {
      console.log("<<<<<<<<<<<<< Hold on Reconnect set timeout >>>>>>>>>>");
      this.createConnection(meetingDetails?.uuid, false);
    }, 1000)
  }

  static async sendScreenShareSocketio(data: object) {
    if (socketIOSDK) {
      socketIOSDK.joinScreenShare(data);
    }
  };
  static async sendActiveSpeakerStatus(SpeakerInfo: any) {
    if (socketIOSDK) {
      socketIOSDK.sendActiveSpeakerStatus(SpeakerInfo);
    }
  };

  static async updateLang(input: any) {
    if (socketIOSDK) {
      socketIOSDK.updateCCLang(input);
    }
  }

  static async endMeeting(type: string, socketId?: any, alternate_host?: any) {
    let enddetails = {
      type,
      socketId,
      alternate_host
    };
    console.log("endMeeting=====", type);

    if (socketIOSDK && type) {
      socketIOSDK.sendCommand('endMeeting', enddetails);
      localStorage.removeItem('isLoggedIn');
      localStorage.removeItem('createConnection');
    }

  };

  static async recordingAction(type: any, conId: any) {
    let input: any = {};
    input.type = type;
    input.socketId = conId;
    if (type === "start") {
      let browser: any = fetchBrowserTpeRec();
      input.browserType = browser;
    }
    if (socketIOSDK)
      socketIOSDK.recordingAction(input);
  }

  static async sendUpdatedSdp(sdp: any) {
    console.log("sending participantList:- ", sdp.participantList);
    console.log("sending sdp to socket:- ", sdp.sdp);
    if (socketIOSDK) { socketIOSDK.sendSDP(sdp); }
  };


  static async audioStatus(data: any) {
    if (socketIOSDK) {
      socketIOSDK.setMuteUnmute(data);
    }
  };

  static async videoStatus(data: any) {
    if (socketIOSDK) {
      socketIOSDK.setHideShow(data);
    }
  };

  static async startCloseCaption(input: any) {
    if (socketIOSDK) {
      socketIOSDK.startCloseCaption(input);
    }
  };
  static async stopCloseCaption(input: any) {
    if (socketIOSDK) {
      socketIOSDK.stopCloseCaption(input);
    }
  };

  static async reqScreenShare(input: any) {
    if (socketIOSDK) {
      socketIOSDK.requestScreenShare(input)
    }
  }

  static async sendTransferDetails(input: any) {
    if (socketIOSDK) {
      socketIOSDK.initiateAgentTransfer(input)
    }
  }

  static async checkShareStatus() {
    try {
      const isScreenShare: sharingState = store.getState().sharingReducerState || [];
      const { sockmeetDetails }: any = store.getState().meetingReducer;
      ;
      let { currdeviceinfo }: any = store.getState().meetingReducer || [];
      let shareStatus: any = { "status": true, "error": "" };
      if (isScreenShare.sharingStatus) {
        if (isScreenShare.conId === currdeviceinfo.conId + "_screenshare") {
          shareStatus.status = false;
          shareStatus.error = "Already you sharing the screen";
        }
        else {
          shareStatus.status = false;
          shareStatus.error = "Already someone sharing the screen";
        }
      }
      else if (sockmeetDetails.restrictScreenShare && !currdeviceinfo.isHost) {
        shareStatus.status = false;
        shareStatus.error = "";
      }

      return shareStatus;
    }
    catch (e: any) { console.log("error is", e); }
  };

  static async sendPrivateChat(tosocketId: string, body: any) {
    if (socketIOSDK) {
      socketIOSDK.sendPrivateMessage({ body, tosocketId, type: 'TEXT' });
    }
  };

  static async sendFilePrivate(meetingId: string, body: any) {
    if (socketIOSDK) {
      socketIOSDK.sendPrivateMessage({ body: JSON.stringify(body), tosocketId: meetingId, type: "FILE" });
    }
  };

  static async refreshClosetab() {
    if (socketIOSDK) {
      socketIOSDK.refreshClosetab({});
    }
  };

  static async getChats(tosocketId: string, chatType: string) {
    if (socketIOSDK) {
      let details = {
        tosocketId,
        chatType
      };
      socketIOSDK.getChatbyType(details);
    }
  };

  static async updateScreenSize(data: any) {
    if (socketIOSDK) {
      socketIOSDK.updateCanvasSize(data);
    }
  };
  static async reqCoBrowsing(data: any) {
    if (socketIOSDK) {
      socketIOSDK.coBrowserReq(data);
    }
  };
  static async declineCoBrowsing(data: any) {
    if (socketIOSDK) {
      socketIOSDK.coBrowserDecline(data);
    }
  };

  static async acceptCoBrowsing(data: any) {
    if (socketIOSDK) {
      socketIOSDK.coBrowserAccept(data);
    }
  }

  static async sendWhiteboardData(data: object) {
    console.log("send white>>", data);
    if (socketIOSDK) {
      socketIOSDK.sendWhiteboard(data);
    }
  };

  public static sendVerificationRequestData(data: any) {
    if (socketIOSDK) {
      socketIOSDK.sendVerificationReq(data);
    }
  }
  public static sendVerificationDetails(data: any) {
    if (socketIOSDK) {
      socketIOSDK.sendVerificationDetails(data);
    }
  }
  static async reqRec(conId: any) {
    let input: any = {};
    input.socketId = conId;
    if (socketIOSDK)
      socketIOSDK.participantRequesttoRecord(input);
  }

  public static sendScreenShareInvite() {
    let { currdeviceinfo }: any = store.getState().meetingReducer || [];
    let jsonData: any = {};
    jsonData.shape = 'SCREENSHARING_STATUS';
    jsonData.status = true;
    jsonData.conId = currdeviceinfo.conId + '_screenshare';
    let input = {
      sipId: currdeviceinfo.conId + '_screenshare',
      message: jsonData,
      type: 'start',
      username: currdeviceinfo.name || "Guestuser"
    };
    videoCallService.sendScreenShare(input)

  };


}



export const updateToParticipants = (details: any) => {
  if (details !== undefined) {
    store.dispatch({
      type: meetActionTypes.CHAT_TO_PARTICIPANTS,
      payload: {
        toParticipant: { conId: details.conId, name: details.name, deviceid: details.deviceid }
      }
    });
  }
};





